<script>
import { authComputed } from '@state/helpers'

export default {
  components: {},
  computed: {
    ...authComputed,
  },
  methods: {},
}
</script>

<template>
  <footer id="mainFooter" class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          2019 - {{ new Date().getFullYear() }} &copy; mindZcloud
        </div>
        <div class="col-md-6">
          <div class="text-md-right footer-links d-none d-sm-block">
            <a href="/">Home</a>
            <a href="https://dev-etp.mindzcloud.com" target="_blank"
              >Training Portal</a
            >
            <a
              href="https://www.mindzcloud.com/enterprise-training-portal"
              target="_blank"
              >Contact Us</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
